// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dyz1","col":"styles_col__1Ima3"};